(() => {
  const initHotspotSection = (sectionRoot) => {
    if (!sectionRoot || sectionRoot.dataset.hotspotsInitialized === "true") return;

    const overlay = sectionRoot.querySelector("[data-hotspot-overlay]");
    const triggers = sectionRoot.querySelectorAll("[data-hotspot-trigger]");
    const modals = sectionRoot.querySelectorAll("[data-hotspot-modal]");
    let activeModal = null;
    let activeTrigger = null;

    const closeAll = () => {
      modals.forEach((modal) => (modal.hidden = true));
      triggers.forEach((trigger) => trigger.setAttribute("aria-expanded", "false"));
      if (overlay) overlay.hidden = true;
      document.body.classList.remove("hotspot-modal-open");

      if (activeTrigger) {
        activeTrigger.focus();
        activeTrigger = null;
      }
      activeModal = null;
    };

    const openModal = (modalId, trigger) => {
      closeAll();
      const modal = sectionRoot.querySelector("#" + modalId);
      if (!modal) return;

      modal.hidden = false;
      if (overlay) overlay.hidden = false;
      document.body.classList.add("hotspot-modal-open");
      trigger.setAttribute("aria-expanded", "true");

      activeModal = modal;
      activeTrigger = trigger;
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", function () {
        openModal(this.getAttribute("data-target"), this);
      });
    });

    sectionRoot.querySelectorAll("[data-hotspot-close]").forEach((btn) => {
      btn.addEventListener("click", closeAll);
    });

    sectionRoot.querySelectorAll("[open-quick-view]").forEach((btn) => {
      btn.addEventListener("click", closeAll);
    });

    if (overlay) overlay.addEventListener("click", closeAll);

    const onKeyDown = (event) => {
      if (event.key === "Escape" && activeModal) closeAll();
    };

    document.addEventListener("keydown", onKeyDown);

    document.addEventListener(
      "shopify:section:unload",
      (event) => {
        if (event.target.contains(sectionRoot)) {
          document.removeEventListener("keydown", onKeyDown);
        }
      },
      { once: true }
    );

    sectionRoot.dataset.hotspotsInitialized = "true";
  };

  const initAllHotspots = (scope = document) => {
    scope.querySelectorAll("[data-image-hotspots-section]").forEach(initHotspotSection);
  };

  document.addEventListener("DOMContentLoaded", () => initAllHotspots());
  document.addEventListener("shopify:section:load", (event) => initAllHotspots(event.target));
})();
